// extracted by mini-css-extract-plugin
module.exports = {"zIndexToolTip":"13380000","wrapper":"styles_wrapper___zbes","list":"styles_list__1UmHk","badgeCountContainer":"styles_badgeCountContainer__3zYJ2"};